import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import INotaState from "./models/INotaState";
import NotaAsRead from "./models/NotaAsRead";
import NotaEstimateModel from "./models/NotaEstimateModel";
import NotaOrderModel from "./models/NotaOrderModel";
import NoteTopicsModel from "./models/NoteTopicsModel";
import NuovoNotaFormModel from "./models/NuovoNotaFormModel";
import NotaAction from "./NotaAction";

export default class MessaggioReducer extends BaseReducer<INotaState> {
    public readonly initialState: INotaState = {
        estimateNote: [],
        noteTopics: new NoteTopicsModel({}),
        noteTopicsTotal: 0,
        noteTopicsForm: new NotaOrderModel({
            colName: "idEstimate",
            direction: "D",
        }),
        nuovoNotaForm: new NuovoNotaFormModel({}),
        nuovaNota: new NotaEstimateModel({}),
        notaInterna: false,
        notaDetails: new NotaEstimateModel({}),
        readNote: new NotaAsRead({}),
    };

    public [NotaAction.REQUEST_GET_NOTE_PREVENTIVO_FINISHED](
        state: INotaState,
        action: IAction<NotaEstimateModel[]>
    ): INotaState {
        return {
            ...state,
            estimateNote: action.payload!,
        };
    }

    public [NotaAction.REQUEST_ADD_NOTE_FINISHED](state: INotaState, action: IAction<NotaEstimateModel>): INotaState {
        return {
            ...state,
            nuovaNota: action.payload!,
        };
    }

    public [NotaAction.REQUEST_GET_NOTE_TOPICS_FINISHED](
        state: INotaState,
        action: IAction<NoteTopicsModel>
    ): INotaState {
        return {
            ...state,
            noteTopics: action.payload!,
            noteTopicsTotal: action.payload?.data.length!,
        };
    }

    public [NotaAction.REQUEST_NOTE_TABLE_FORM](state: INotaState, action: IAction<NotaOrderModel>): INotaState {
        return {
            ...state,
            noteTopicsForm: action.payload!,
        };
    }

    public [NotaAction.REQUEST_NUOVA_NOTA_FORM_SET](
        state: INotaState,
        action: IAction<NuovoNotaFormModel>
    ): INotaState {
        return {
            ...state,
            nuovoNotaForm: action.payload!,
        };
    }

    public [NotaAction.REQUEST_SET_NOTA_INTERNA](state: INotaState, action: IAction<boolean>): INotaState {
        return {
            ...state,
            notaInterna: action.payload!,
        };
    }

    public [NotaAction.REQUEST_RESET_NUOVA_NOTA](state: INotaState, action: IAction<NuovoNotaFormModel>): INotaState {
        return {
            ...state,
            nuovoNotaForm: this.initialState.nuovoNotaForm,
        };
    }

    public [NotaAction.REQUEST_NOTA_DETAILS](state: INotaState, action: IAction<NotaEstimateModel>): INotaState {
        return {
            ...state,
            notaDetails: action.payload!,
        };
    }

    public [NotaAction.REQUEST_SET_NOTE_AS_READ_FINISHED](state: INotaState, action: IAction<NotaAsRead>): INotaState {
        return {
            ...state,
            readNote: action.payload!,
        };
    }
}
